var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/render-promo-entry.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["promoEntry"], 
["classes"], 
function (l_promoEntry, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("promoEntry", l_promoEntry);
frame.set("classes", kwargs.hasOwnProperty("classes") ? kwargs["classes"] : "lazyload");
var t_2 = "";t_2 += "\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"reduced")) {
t_2 += "\n        ";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality");
frame.set("imageQuality", t_3, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_3);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_3);
}
t_2 += "\n    ";
;
}
else {
if((lineno = 3, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_promoEntry,"alternateImageQuality"]))) {
t_2 += "\n        ";
var t_4;
t_4 = (lineno = 4, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_promoEntry,"alternateImageQuality"]));
frame.set("imageQuality", t_4, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_4);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_4);
}
t_2 += "\n    ";
;
}
else {
t_2 += "\n        ";
var t_5;
t_5 = ((lineno = 6, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_promoEntry,"primaryImageQuality"]))?(lineno = 6, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_promoEntry,"primaryImageQuality"])):runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"default_image_quality"));
frame.set("imageQuality", t_5, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_5);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_5);
}
t_2 += "\n    ";
;
}
;
}
t_2 += "\n\n    ";
if(runtime.memberLookup((l_promoEntry),"url")) {
t_2 += "\n    <a href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promoEntry),"url"), env.opts.autoescape);
t_2 += "\" ";
if(runtime.memberLookup((l_promoEntry),"openLinkInNewWindow")) {
t_2 += "target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
t_2 += ">\n    ";
;
}
t_2 += "\n\n        <img data-src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promoEntry),"primaryImage"), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "imageQuality")) {
t_2 += "?q=";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageQuality"), env.opts.autoescape);
;
}
t_2 += "\" ";
if(runtime.memberLookup((l_promoEntry),"alternateText")) {
t_2 += "alt=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promoEntry),"alternateText"), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += " class=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
t_2 += "\"/>\n\n    ";
if(runtime.memberLookup((l_promoEntry),"url")) {
t_2 += "\n    </a>\n    ";
;
}
t_2 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("renderPromo");
context.setVariable("renderPromo", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/render-promo-entry.j2"] , dependencies)